import { submitBroadcastRequest } from "../../../api/broadcast/submitbroadcast.service";
import { SUBMIT_BROADCAST } from "../actionTypes";

const request = () => ({ type: SUBMIT_BROADCAST.REQUEST });
const failure = (error) => ({ type: SUBMIT_BROADCAST.FAILURE, error });
const success = () => ({ type: SUBMIT_BROADCAST.SUCCESS });

export const SubmitBroadcastRequst = (payload) => {
  return (dispatch, getState) => {
    dispatch(request());
    return submitBroadcastRequest(payload)
      .then((res) => {
        dispatch(success(res));
        return Promise.resolve({res:res,status:true});

      })
      .catch((error) => {
        dispatch(failure(error?.message));
        return Promise.resolve({error:error?.message,status:false});
      });
  };
};